module.exports = __webpack_public_path__ + "media/backgrounds/enq-1998-AKs-_E7bpUg-unsplash-e09950c9.jpg";